import { InnoTable } from "InnoUI/components";
import {
  formatDateTime,
  innoTableConfig,
  InnoTableDefaultPageSize,
} from "utils/config";
import SC from "./style";
import React, { useEffect, useState } from "react";
import InnoIcons from "@InnoIcons/";
import TimezoneConverter from "components/TimeZoneConvertor";

const HistoryTable = (props) => {
  const { data } = props;
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(InnoTableDefaultPageSize.pageSize);

  useEffect(() => {
    if (data) {
      setLoading(false);
    } else {
      setLoading(true);
    }
  }, [data]);

  const onAddDataCallback = () => {};

  const onRowClick = (data) => {};

  const subColumnData = [
    {
      title: "S.No.",
      dataIndex: "id",
      width: 50,
      render(value, record, index) {
        const serialNumber = (currentPage - 1) * pageSize + index + 1;
        return <p>{serialNumber}</p>;
      },
    },
    {
      title: "Event",
      dataIndex: "event",
      sorter: (a, b) => a.event.localeCompare(b.event),
      showSorterTooltip: { target: "sorter-icon" },
      sortDirections: ["ascend", "descend"],
      onCell: () => ({
        style: { width: "350px" },
      }),
      render(value, record) {
        return <SC.ValueSpanP>{value}</SC.ValueSpanP>;
      },
    },
    {
      title: "Name",
      dataIndex: "createdByName",
      sorter: (a, b) => a.createdByName.localeCompare(b.createdByName),
      showSorterTooltip: { target: "sorter-icon" },
      sortDirections: ["ascend", "descend"],
      onCell: () => ({
        style: { width: "350px" },
      }),
      render(value, record) {
        return <SC.ValueSpanP>{value}</SC.ValueSpanP>;
      },
    },

    {
      title: "Date & Time",
      dataIndex: "createdOn",

      onCell: () => ({
        style: { width: "250px" },
      }),
      render(value, record, index) {
        return (
          <SC.ValueSpan>
            <TimezoneConverter time={value || "N/A"} />
          </SC.ValueSpan>
        );
      },
    },
  ];

  const tableConfig = {
    draggable: false,
    selection: false,
    expandable: true,
    sno: false,
    addNew: false,
    pagination: {
      current: currentPage, // current page number
      pageSize: pageSize, // page size state
      // pageSizeOptions: ["20", "50", "100"], // options shown in the dropdown
      showSizeChanger: true, // enable page size dropdown
      onChange: (page, pageSize) => {
        setCurrentPage(page);
        setPageSize(pageSize); // this is important to update
      },
    },
    search: false,
    action: false,
    divBorder: false,
  };

  return (
    <>
      <SC.Container>
        <InnoTable
          tableConfig={tableConfig}
          loading={loading}
          padding="8px 8px"
          column={subColumnData}
          data={data}
          tableKey=""
          searchKeys={["propertyName", "displayTemplateName"]}
          onRowClickCallback={onRowClick}
          onAddDataCallback={onAddDataCallback}
        />
      </SC.Container>
    </>
  );
};

export default React.memo(HistoryTable);
